export const TEST_ID = 'skeletonAvatar';
